@if (briefId()) {
  <admin-brief-details [briefId]="briefId()!" />
}
